import clsx from 'clsx'
import {KTSVG} from '../../../../../_gori/helpers'

export type MessageItemLinkProps = {
  text: string
  url: string
}
export const MessageItemLink = ({text, url}: MessageItemLinkProps) => {
  return (
    <a
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      className={
        'chatbot-icon text-white text-hover-primary px-3 py-1 rounded-pill bg-primary bg-hover-light align-items-center gap-2 d-flex'
      }
    >
      {text}
      <KTSVG path='/media/gori/chatbot/navigate.svg' className={clsx('svg-icon svg-icon-2')} />
    </a>
  )
}
